// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2ziFi","page":"App_page__1AVsN","wrapper":"App_wrapper__RCHjb"};